module.exports = __webpack_public_path__ + "assets/src/style/img/here-and-now.png?4e2bebbfea682721b3328e11387a7462";